<template>
  <div class="supporter" v-if="user.perfil">
    <Header />
    <div class="content">
      <router-view></router-view>
    </div>
   <!--  <Chat /> -->
    <Status />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import Chat from "@/components/Chat.vue";
import Header from "@/components/HeaderSupporter.vue";
import Status from "@/components/Status.vue";

export default {
  name: "home",
  components: {
    // Chat,
    Header,
    Status,
  },
  methods: {
    ...mapActions("user", ["CONF"]),
  },
  beforeMount() {
    this.CONF().then(r => {
      if (r && r.data && r.data.app_version) {

        let version = parseInt(r.data.app_version)
        let ov = localStorage.getItem("VERSION") || 0

        if (version > parseInt(ov)) {
          localStorage.setItem("VERSION", version)
          window.location.reload(true)
        }
      }
    })
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>
<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.supporter
  input, textarea, select
    height: 44px
    padding: 0 8px
    border: none
    width: 92%
    border-bottom: 3px solid #ddd
    border-radius: 8px
    box-shadow: none
    background: none
    &:focus
      background: rgba($purple,.1)
      border-bottom: 3px solid $purple
  input[type='checkbox']
    width: 18px
    height: 18px
  textarea
    min-height: 160px
    padding-top: 12px
</style>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.supporter 
  .content
    padding: 42px 35px
    @media (max-width: $small)
      padding: 7px
</style>
